import React from 'react'

export default function NotFound() {
  return (
    <div className="error-page">
      <div className="error-container">
        <img className="error-figure" src='/images/404.png' alt="404" />
        <p className="error-title">访问的页面不存在</p>
      </div>
    </div>
  )
}
